<template>
	<div>
		<div class="flex">
			<CustomerSearch v-model="customer" />
			<div class="flex-grow flex horizontal-flex-end">
				<template v-if="loading_stylists">
					Loading stylists ...
				</template>
				<MaterialDropdown label="Stylist" v-else v-model="stylist_id" :options="stylistList" />
			</div>
		</div>

		<div v-if="Object.keys(customer).length" class="margin-top">
			<h3>Selected customer</h3>
			<div class="flex align-items">
				<Flag :localeid="customer.locale.locale_id" />
				<div class="small-margin-left">
					{{ customer.full_name }}
				</div>
			</div>
			<div class="margin-top">
				<template v-if="loading_timeslots">Loading timeslots</template>
				<template v-else>
					<template v-if="booking">
						Booking ...
					</template>
					<template v-else>
						<h3>Timeslots</h3>
						<div v-for="(date, dateString) in timeslots">
							<strong>{{ dateString }}</strong>
							<div class="flex flex-wrap">
								<div
									v-for="(timeslot, time) in date.timeslots"
									v-if="timeslot.available"
									style="padding: 6px;"
									class="border small-margin-right small-margin-bottom clickable"
									v-on:click="book(dateString, time)">
									{{ time }}
								</div>
							</div>
						</div>
					</template>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    customer: {},
    timeslots: {},
    loading_timeslots: false,
    loading_stylists: false,
    booking: false,
    stylist_id: '',
    stylists: []
  }),
  watch: {
    customer: function () {
      if (Object.keys(this.customer).length) {
        this.loadTimeslots()
      }
    }
  },
  computed: {
    stylistList () {
      var list = {
        '': '[ Any available ]'
      }

      for (var stylist of this.stylists) {
        list[stylist.id] = stylist.shortened_name
      }

      return list
    }
  },
  methods: {
    loadTimeslots () {
      Vue.$api.get('/customer/' + this.customer.id + '/scheduled-call/calendar', {}, {
        loader: toggle => this.loading_timeslots = toggle,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.timeslots = data
    },
    book (date, time) {
      Vue.$api.post('/scheduled-call/book', {
        user_id: this.customer.id,
        datetime: date + ' ' + time,
        stylist: this.stylist_id
      }, {
        loader: toggle => this.booking = toggle,
        callback: () => this.booked()
      })
    },
    booked () {
      this.$emit('success')
    },
    loadStylists () {
      Vue.$api.get('/stylists', {}, {
        callback: data => this.stylists = data,
        loader: toggle => this.loading_stylists = toggle
      })
    }
  },
  created () {
    this.loadStylists()
  }
}
</script>
